import React, { Component } from "react";

interface TimerState {
	seconds: number;
	isRunning: boolean;
}

interface TimerProps {
	style?: React.CSSProperties;
}

class Timer extends Component<TimerProps, TimerState> {
  private timerID: any | undefined;

  constructor(props) {
    super(props);
    this.state = {
      seconds: 0,
      isRunning: false,
    };
  }

  componentDidMount() {
    this.startTimer();
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  startTimer() {
    if (!this.state.isRunning) {
      this.timerID = setInterval(() => {
        this.setState((prevState) => ({
          seconds: prevState.seconds + 1,
        }));
      }, 1000);

      this.setState({ isRunning: true });
    }
  }

  stopTimer() {
    if (this.state.isRunning) {
      clearInterval(this.timerID);
      this.setState({ isRunning: false });
    }
  }

  resetTimer() {
    this.stopTimer();
    this.setState({ seconds: 0 });
    this.startTimer();
  }

  formatTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
  };

  render() {
    return (
      <div style={this.props.style}>
        {/* <h1>计时器</h1> */}
        {/* <p>秒数：{this.state.seconds}</p>
        <button onClick={() => this.startTimer()}>开始</button>
        <button onClick={() => this.stopTimer()}>停止</button>
        <button onClick={() => this.resetTimer()}>重置</button> */}
		<span>{this.formatTime(this.state.seconds)}</span>
      </div>
    );
  }
}

export default Timer;
